// import authApi from '../api/AuthApi';
import authApi from '../api/AuthApi';
import { Auth } from '../model/entities';
import jwt_decode from 'jwt-decode';

class AuthService {
    auth: Auth | undefined;
    accessToken: string | undefined;

    get = async (): Promise<Auth | undefined> => {
        try {
            this.accessToken = await authApi.getAccessToken();
            this.auth = this.createAuth(this.accessToken);
        } catch {
            this.auth = undefined;
            this.accessToken = undefined;
        }

        return this.auth;
    };

    createAccessToken = async (workDocsAccessToken?: string): Promise<Auth | undefined> => {
        try {
            this.accessToken = await authApi.createAccessToken(workDocsAccessToken);
            this.auth = this.createAuth(this.accessToken);
        } catch {
            this.auth = undefined;
            this.accessToken = undefined;
        }

        return this.auth;
    };

    refreshAccessToken = async () => {
        try {
            this.accessToken = await authApi.getAccessToken();
        } catch {
            this.accessToken = undefined;
        }
    };

    logOut = async () => {
        await authApi.logOut();
        this.auth = undefined;
        this.accessToken = undefined;
    };

    /**
     * Creates an Auth from an access token.
     * @param accessToken - the access token
     * @returns the auth
     */
    private createAuth = (accessToken: string): Auth => {
        const decodedAccessToken: any = jwt_decode(accessToken);
        return {
            id: decodedAccessToken.id,
            email: decodedAccessToken.sub,
            firstName: decodedAccessToken.firstName,
            lastName: decodedAccessToken.lastName,
            authorities: decodedAccessToken.scopes.split(' '),
            workDocsAccessToken: decodedAccessToken.workDocsAccessToken,
        };
    };
}

const authService: AuthService = new AuthService();
export default authService;
